import { useState } from "react";

/**
 * 販売原票一括入力　原票差分管理hook
 */
export const useHistoryItems = () => {
  const [historyItems, setHistoryItems] = useState([]);

  const changeHistoryItem = (salesRecordNo, detailId, propName, value) => {
    const isHeaderChange =  ['acceptanceLabelNo', 'directorEmployeeId', 'partition'].includes(propName);

    const index = historyItems.findIndex((item) => (
      item.salesRecordNo == salesRecordNo
        && (isHeaderChange  || item.itemRow == detailId)
        && item.itemProp == propName
    ));

    const newHistoryItem = {
      salesRecordNo,
      itemRow: isHeaderChange  ? 0 : detailId,
      itemCategory: isHeaderChange  ? 'header' : 'detail',
      itemProp: propName,
      value
    };

    if (index >= 0) {
      setHistoryItems(
        historyItems.map((item, itemIndex) => (
          itemIndex == index
            ? newHistoryItem
            : item
        ))
      );
      return;
    }

    setHistoryItems([...historyItems, newHistoryItem]);
  }

  const clearHistoryItems = () => {
    setHistoryItems([]);
  }

  return { 
    historyItems,
    changeHistoryItem,
    clearHistoryItems
  };
  
}


